import { SettingConst } from '@faire/web-api--source/types';

/**
 * Used to control a locked product tile view of preorderable products and IDV flow
 */
export const PREORDER_IDV_SELF_SUBMIT =
  'PREORDER_IDV_SELF_SUBMIT' as SettingConst<
    'PREORDER_IDV_SELF_SUBMIT',
    boolean,
    'RETAILER' | 'VISITOR_WEB'
  >;
